import { serialize } from 'object-to-formdata';

export const jsonToFormData = (jsonObject) => {
  return serialize(jsonObject, { indices: true, booleansAsIntegers: true });
};
